<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :title="$t('analytics.info.recruitment_process.title').toString()"
            icon="stacked-line-chart"
        ></graph-title>
        <div class="flex flex-wrap space-y-16 mt-16">
            <div class="w-full">
                <div class="rounded bg-white border border-primary-20 p-24 relative">
                    <div v-if="fetching" class="absolute inset-0 flex items-center justify-center">
                        <loading color="blue" size="small"></loading>
                    </div>
                    <div :class="[ fetching ? 'opacity-0' : 'opacity-100' ]">
                        <p class="font-semibold text-body text-center mb-8">{{ $t('jobs.stats.interviews') }}
                            ({{ interviewCount }}) vs {{ $t('jobs.stats.candidates') }} ({{ applicationCount }})</p>
                        <p class="text-black text-center">
                            {{ $t('analytics.info.recruitment_process.interviews_applicants.description') }}
                        </p>
                        <div class="my-20">
                            <div class="overflow-hidden h-24 text-primary-80 flex transition-all duration-500 w-full">
                                <div :style="'width:' + ratio_one + '%'" class="h-full bg-[#008FFB]"></div>
                                <div :style="'width:' + (100 - ratio_one) + '%'" class="h-full bg-[#00E396]"></div>
                            </div>
                        </div>
                        <b class="block text-body text-center leading-none font-semibold">
                            {{ (ratio_one === 0 ? '-' : ratio_one) }}
                            <span v-if="ratio_one > 0">%</span>
                            <span v-if="ratio_one > 0">{{ $t('analytics.conversion_rate') }}</span>
                        </b>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="rounded bg-white border border-primary-20 p-24 relative">
                    <div v-if="fetching" class="absolute inset-0 flex items-center justify-center">
                        <loading color="blue" size="small"></loading>
                    </div>

                    <div :class="[ fetching ? 'opacity-0' : 'opacity-100' ]">
                        <p class="font-semibold text-body text-center mb-8">{{ $t('analytics.stats.recruitments') }}
                            ({{ completedCount }}) vs {{ $t('jobs.stats.candidates') }} ({{ applicationCount }})</p>
                        <p class="text-black text-center">
                            {{ $t('analytics.info.recruitment_process.hired_applicants.description') }}
                        </p>
                        <div class="my-20">
                            <div class="overflow-hidden h-24 text-primary-80 flex transition-all duration-500 w-full">
                                <div :style="'width:' + ratio_two + '%'" class="h-full bg-[#008FFB]"></div>
                                <div :style="'width:' +  (100 - ratio_two) + '%'" class="h-full bg-[#00E396]"></div>
                            </div>
                        </div>
                        <b class="block text-body text-center leading-none font-semibold">
                            {{ (ratio_two === 0 ? '-' : ratio_two) }}
                            <span v-if="ratio_two > 0">%</span>
                            <span v-if="ratio_two > 0">{{ $t('analytics.conversion_rate') }}</span>
                        </b>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="rounded bg-white border border-primary-20 p-24 relative">
                    <div v-if="fetching" class="absolute inset-0 flex items-center justify-center">
                        <loading color="blue" size="small"></loading>
                    </div>

                    <div :class="[ fetching ? 'opacity-0' : 'opacity-100' ]">
                        <p class="font-semibold text-body text-center mb-8">{{ $t('analytics.stats.recruitments') }}
                            ({{ completedCount }}) vs {{ $t('jobs.stats.interviews') }} ({{ interviewCount }})</p>
                        <p class="text-black text-center">
                            {{ $t('analytics.info.recruitment_process.hired_interviews.description')}}
                        </p>
                        <div class="my-20">
                            <div class="overflow-hidden h-24 text-primary-80 flex transition-all duration-500 w-full">
                                <div :style="'width:' + ratio_three + '%'" class="h-full bg-[#008FFB]"></div>
                                <div :style="'width:' +  (100 - ratio_three) + '%'" class="h-full bg-[#00E396]"></div>
                            </div>
                        </div>
                        <b class="block text-body text-center leading-none font-semibold">
                            {{ (ratio_three === 0 ? '-' : ratio_three) }}
                            <span v-if="ratio_three > 0">%</span>
                            <span v-if="ratio_three > 0">{{ $t('analytics.conversion_rate') }}</span>
                        </b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as analytics from "../../services/AnalyticsService";
import analyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle";
import Loading from "../ui/Loading";
import SvgIcon from '../ui/SvgIcon';

export default {
    name: 'RecruitProcess',
    components: {
        Loading,
        SvgIcon,
        GraphTitle,
    },
    mixins: [analyticsMixins],
    props: {
        filterFields: Object,
    },
    data() {
        return {
            interviews: null,
            interviewCount: 0,
            applicationCount: 0,
            completedCount: 0,
            ratio_one: 0,
            ratio_two: 0,
            ratio_three: 0,
        }
    },
    methods: {
        async fetchData(fresh) {
            if (this.lockFetch || (!this.sendRequest() && !fresh)) {
                this.fetching = false;
                return;
            }
            return await analytics.recruitProcess(this.filterFields).then(response => {
                this.interviewCount = response.interviewCount;
                this.applicationCount = response.applicationCount;
                this.completedCount = response.completedCount;
                this.ratio_one = response.ratioOne;
                this.ratio_two = response.ratioTwo;
                this.ratio_three = response.ratioThree;
            }).then(() => {
                this.fetching = false;
            })
        },
    },
}
</script>
